// src/components/Layout/AppLayout.tsx
import React from 'react';
import * as styles from './AppLayout.css';

interface Props {
  background: 'gradient' | 'solid';
  children: React.ReactNode;
}

export const AppLayout: React.FC<Props> = ({ background, children }) => {
  return (
    <div className={styles.root({ background })}>
      {children}
    </div>
  );
};